import DOMPurify from 'dompurify'

// FORCE_BODY keeps the payload's leading <style> block, which the parser would
// otherwise hoist into <head> and drop, taking the receipt's whole design with it.
export const sanitizeReceiptHtml = (receiptHtml: string): string =>
  DOMPurify.sanitize(receiptHtml, { FORCE_BODY: true })
